/* ══════════════════════════════════════════════════════════════════════
   BB FRAGRANCES · Collection page behaviour
   Four jobs, no dependencies, no framework:
     1. Product ⇄ Lifestyle image switch      (remembered per visitor)
     2. Column count: 3/4 desktop, 1/2 mobile (remembered per visitor)
     3. Filters — submitted through the Section Rendering API so the grid
        updates without a page load; falls back to a normal GET form
     4. Add to cart, and the wishlist heart (local only — see README)
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var LS = {
    view: 'bbf:collection:view',
    cd: 'bbf:collection:cols-d',
    cm: 'bbf:collection:cols-m',
    wish: 'bbf:wishlist'
  };
  function get(k, f) { try { return localStorage.getItem(k) || f; } catch (e) { return f; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function init(root) {
    if (!root || root.dataset.bbfReady) return;
    root.dataset.bbfReady = '1';

    var grid = root.querySelector('[data-bbf-grid]');
    var sectionId = root.dataset.sectionId;

    /* ── 1 · image view ─────────────────────────────────────────────── */
    var viewBtn = root.querySelector('[data-bbf-view]');
    function paintView(v) {
      if (grid) grid.setAttribute('data-view', v);
      if (viewBtn) {
        viewBtn.textContent = v === 'product' ? viewBtn.dataset.labelToLifestyle : viewBtn.dataset.labelToProduct;
        viewBtn.setAttribute('aria-pressed', String(v === 'lifestyle'));
      }
    }
    if (viewBtn) {
      paintView(get(LS.view, grid ? grid.getAttribute('data-view') : 'product'));
      viewBtn.addEventListener('click', function () {
        var next = grid.getAttribute('data-view') === 'product' ? 'lifestyle' : 'product';
        set(LS.view, next);
        paintView(next);
      });
    }

    /* ── 2 · columns ────────────────────────────────────────────────── */
    function paintCols(scope, n) {
      if (!grid) return;
      grid.style.setProperty(scope === 'd' ? '--cols-d' : '--cols-m', n);
      root.querySelectorAll('[data-bbf-cols="' + scope + '"] button').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.n === String(n)));
      });
      set(scope === 'd' ? LS.cd : LS.cm, n);
    }
    ['d', 'm'].forEach(function (scope) {
      var wrap = root.querySelector('[data-bbf-cols="' + scope + '"]');
      if (!wrap) return;
      var stored = get(scope === 'd' ? LS.cd : LS.cm, wrap.dataset.default);
      paintCols(scope, stored);
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-n]');
        if (b) paintCols(scope, b.dataset.n);
      });
    });

    /* ── 3 · filters ────────────────────────────────────────────────── */
    var drawer = root.querySelector('[data-bbf-filters]');
    var drawerBtn = root.querySelector('[data-bbf-filter-toggle]');
    if (drawerBtn && drawer) {
      drawerBtn.addEventListener('click', function () {
        var closed = drawer.classList.toggle('is-closed');
        drawerBtn.setAttribute('aria-expanded', String(!closed));
        drawerBtn.textContent = (closed ? drawerBtn.dataset.labelOpen : drawerBtn.dataset.labelClose);
      });
    }

    var busy = null;
    function load(url, push) {
      if (!sectionId) { window.location.href = url; return; }
      if (busy) busy.abort();
      busy = new AbortController();
      if (grid) grid.classList.add('is-loading');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=' + sectionId, { signal: busy.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-bbf-root]');
          if (!fresh) { window.location.href = url; return; }
          root.innerHTML = fresh.innerHTML;
          delete root.dataset.bbfReady;
          if (push !== false) history.pushState({ bbf: 1 }, '', url);
          init(root);
          var top = root.getBoundingClientRect().top + window.pageYOffset - 24;
          if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
        })
        .catch(function (err) { if (err.name !== 'AbortError') window.location.href = url; });
    }

    var form = root.querySelector('[data-bbf-filter-form]');
    if (form) {
      form.addEventListener('change', function () {
        var qs = new URLSearchParams(new FormData(form)).toString();
        load(form.action.split('?')[0] + (qs ? '?' + qs : ''));
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qs = new URLSearchParams(new FormData(form)).toString();
        load(form.action.split('?')[0] + (qs ? '?' + qs : ''));
      });
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bbf-link]');
      if (!a) return;
      e.preventDefault();
      load(a.href);
    });
    window.addEventListener('popstate', function () { load(window.location.href, false); });

    /* ── 4 · cart + wishlist ────────────────────────────────────────── */
    var wish = {};
    try { wish = JSON.parse(get(LS.wish, '{}')) || {}; } catch (e) {}
    root.querySelectorAll('[data-bbf-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(!!wish[b.dataset.bbfWish]));
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bbf-wish]');
      if (!b) return;
      var id = b.dataset.bbfWish;
      wish[id] = !wish[id];
      if (!wish[id]) delete wish[id];
      b.setAttribute('aria-pressed', String(!!wish[id]));
      set(LS.wish, JSON.stringify(wish));
      document.dispatchEvent(new CustomEvent('bbf:wishlist:change', { detail: { id: id, saved: !!wish[id] } }));
    });


  }


  /* ── card behaviour, bound once on the document ──────────────────────
     These used to hang off [data-bbf-root], which exists only inside the
     collection grid. The same card now renders on the homepage, in search
     and under a PDP, so the listeners are delegated from the document and
     work wherever a card appears. Delegation also means cards swapped in
     by the Section Rendering API need no re-binding. */

  /* Keep the price in step with the chosen size. Every figure is already
     on the option, pre-formatted by Liquid, so switching size costs no
     request and cannot disagree with what the cart will charge. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-bbf-variant]');
    if (!sel) return;
    var card = sel.closest('article') || sel.closest('[data-bbf-card]') || sel.parentNode;
    var priceEl = card ? card.querySelector('[data-bbf-price]') : null;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    if (priceEl) {
      var cmp = Number(opt.dataset.compare || 0), now = Number(opt.dataset.price || 0);
      priceEl.innerHTML = (cmp > now ? '<s>' + opt.dataset.moneyCompare + '</s>' : '') + opt.dataset.money;
    }
    var btn = sel.form ? sel.form.querySelector('.bbf-atc') : null;
    if (btn) btn.disabled = opt.dataset.available !== 'true';
  });

  /* ── tell the theme the cart moved ───────────────────────────────────
     Broadcast's header badge is a custom element listening for
     theme:cart:change and reading detail.cartCount; its drawer re-renders
     on theme:cart:refresh and opens on theme:product:added. The events
     this used to fire — theme:cart:reload and theme:cart:open — are
     listened for by nothing at all, which is why an add from a card
     reached the cart but never the badge.

     The count is read back from /cart.js rather than counted here, so a
     line that merged with an existing one is still reported correctly.
     ------------------------------------------------------------------ */
  function cartChanged(open) {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    if (open) document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cartCount: cart.item_count }
        }));
      })
      .catch(function () { /* the drawer refresh above is the fallback */ });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-bbf-add]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.classList.add('is-busy'); btn.textContent = btn.dataset.labelAdding || 'Adding'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(f.querySelector('[name="id"]').value), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn) { btn.classList.remove('is-busy'); btn.textContent = btn.dataset.labelAdded || 'Added'; }
        cartChanged(true);
        document.dispatchEvent(new CustomEvent('bbf:cart:add'));
        setTimeout(function () { if (btn) btn.textContent = label; }, 2200);
      })
      .catch(function () { f.submit(); });
  });

  function boot() { document.querySelectorAll('[data-bbf-root]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
  /* theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-bbf-root]');
    if (r) init(r);
  });
})();

/* ──────────────────────────────────────────────────────────────────────────
   Card media — reveal the second frame on a touch device.

   Desktop does this in CSS on :hover. A touch device has no hover, so a
   horizontal drag across the image toggles .is-alt, which the same CSS reads:
   drag left for the second frame, right to come back.

   Only cards inside .bbf-grid take part. The same card also appears inside
   Broadcast sliders on the homepage, and there the horizontal gesture belongs
   to the slider, not to us.

   Nothing calls preventDefault on the touch events, so vertical scrolling is
   untouched; a drag is only read as a swipe when it is clearly sideways. The
   click that a browser fires after a drag is swallowed once, otherwise every
   swipe would also open the product.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  var media = null, startX = 0, startY = 0;

  document.addEventListener('touchstart', function (e) {
    media = null;
    if (!e.target.closest) return;
    var m = e.target.closest('.bbf-grid .bbf-card__media');
    if (!m || m.hasAttribute('data-bbf-single')) return;
    media = m;
    startX = e.changedTouches[0].clientX;
    startY = e.changedTouches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!media) return;
    var m = media;
    media = null;

    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;

    m.classList.toggle('is-alt', dx < 0);

    function swallow(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      done();
    }
    function done() {
      m.removeEventListener('click', swallow, true);
      clearTimeout(timer);
    }
    var timer = setTimeout(done, 400);
    m.addEventListener('click', swallow, true);
  }, { passive: true });
})();
